export default "__VITE_ASSET__CT$tECgS__"